export default {
  DEPLOYMENT_CENTER: 'deployment-center',
  COPILOT: 'copilot',
  COPILOT_CATEGORIZATION: 'copilot_categorization',
  COPILOT_SUMMARIZE_THREAD: 'copilot_summarize_thread',
  COPILOT_ASK_CHAT: 'copilot_ask_chat',
  AGREEMENTS_VIEW_ONLY: 'agreements_view_only',
  NEW_BLANK_FLOW_OPERATORS: 'new_blank_flow_operators',
  DYNAMIC_SLA: 'dynamic_sla',
  SPLIT_THE_THREAD: 'split_the_thread',
  PLANNER: 'planner',
  PLANNER_SYNC_MEMBERS: 'planner-sync-members-with-channels',
  TIMEZEST_INTEGRATION: 'timezest_integration',
  PLANNER_RESTRICT_TO_MEMBER_CHANNELS: 'planner_restrict_to_member_channels',
  PRODUCT_PAYWALL: 'product-paywall'
};
